export const languages = {
  Pt: {
    language_label: "Idioma",
    theme_label: "Tema",
    workbooks: "Cadernos",
    answered_questions: "Quais questões foram respondidas?",
    start_evaluation: "Iniciar avaliação",
    start_evaluation_title: "Caderno de Questões da avaliação",
    start_evaluation_hint: 'Clique no botão "Iniciar avaliação" para iniciar',
    workbook_finished_title: "Caderno de Questão Finalizado",
    workbook_finished_hint: "Você chegou no fim desse caderno",
    redaction_sheet: "Folha de redação",
    support_text: "Texto de apoio",
    statement: "Enunciado",
    save_finish_redaction: "Salvar e finalizar redação",
    redaction_finished_title: "Redação finalizada com sucesso",
    redaction_finish_confirm_title: "Você tem certeza que deseja finalizar a redação?",
    redaction_finish_warning: "Ao finalizar você não poderá realizar mais nenhuma alteração nesta redação",
    redaction_finished_card_title: "Caderno de Redação Finalizado",
    redaction_finished_hint: "Você finalizou este caderno",
    max_lines_reached: "O número máximo de {count} linhas foi atingido",
    line_limit_exceeded: "Você ultrapassou o limite de {count} linhas!",
    warning_title: "Aviso!",
    title_placeholder: "Título",
    go_to_other_workbooks: "Quer ir para outro(s) caderno(s)?",
    next_workbook_hint: "Clique abaixo para avançar para o próximo caderno",
    next_evaluation: "Próxima avaliação",
    all_workbooks_finished: "Todos os cadernos foram finalizados. Deseja encerrar a avaliação?",
    finish_and_submit_evaluation: "Encerrar e entregar avaliação",
    previous: "Anterior",
    next: "Próxima",
    back_to_top: "Voltar ao topo",
    question: "Questão",
    answer_question_to_continue: "Responda a pergunta para avançar",
    answered_exclamation: "Respondida!",
    correct_answer: "Correta",
    answer: "Resposta",
    response_date: "Data da resposta",
    response_files: "Imagem(ns)/arquivo(s) da resposta",
    appeal_files: "Imagem(ns)/arquivo(s) do recurso",
    approved_status: "Deferido",
    rejected_status: "Indeferido",
    answered_label: "Respondida",
    selected_question: "Questão selecionada",
    question_type: "Tipo de questão",
    answers_from: "Respostas de {name} - {proof}",
    required: "Obrigatório",
    optional: "Opcional",
    save_finish_questionnaire: "Salvar e finalizar questionário",
    error_title: "Erro!",
    finished_title: "Finalizada!",
    ok: "Ok",
    cancel: "Cancelar",
    finish: "Finalizar",
    questionnaire_finish_success: "Questionário finalizado com sucesso!",
    questionnaire_finish_confirm_title: "Você tem certeza que deseja finalizar o questionário?",
    questionnaire_finish_warning: "Ao finalizar você não poderá realizar mais nenhuma alteração neste questionário",
    generic_error: "Algo deu errado. Por favor, tente novamente",
    questionnaire_finished_title: "Questionário finalizado com sucesso",
    questionnaire_finished_hint: "Você chegou no fim desse caderno",
    finalized_success_title: "Avaliação finalizada com sucesso",
    finalized_success_kicker: "Avaliação concluída",
    finalized_success_description: "Confira abaixo suas respostas, resultados e redações disponibilizados para este processo.",
    available_results: "Resultados disponíveis",
    answer_sheet_title: "Folha com suas respostas",
    accuracy_sheet_title: "Relação de acerto/erros",
    exam_booklet_title: "Caderno de prova",
    candidate_name: "Nome do Candidato",
    registration_number: "Número de Inscrição",
    proof: "Prova",
    result: "Resultado",
    correct: "Acertou",
    wrong: "Errou",
    no_answer: "Sem resposta",
    download_answer_sheet: "Baixar folha com suas respostas",
    download_accuracy_sheet: "Baixar relação de acertos e erros",
    download_exam_booklet: "Baixar caderno de prova",
    logout_button: "Clique aqui para Sair",
    generated_at: "Gerado em",
    pdf_answer_sheet: "Relatório de respostas",
    evaluation_in_progress: "Avaliação em andamento",
    evaluation_workbooks_title: "Seus cadernos de avaliação",
    oral_evaluation: "Avaliação oral",
    request_pause: "Pedir Pausa",
    start_pause: "Iniciar Pausa",
    pause_request_pending: "Sua solicitação de pausa está em andamento",
    pause_request_denied: "Sua solicitação de pausa foi negada pelo fiscal",
    pause_request_accepted: "Sua solicitação de pausa foi aceita!",
    pause_started_answers_locked: "Ao iniciar a pausa, você não poderá mais alterar as respostas das questões que você já visualizou.",
    pause_access_questions_hint: "Para acessar essas questões, navegue clicando na questão pelo controle de resposta. Exemplo:",
    answered_question_short: "Foi respondida?",
    actions: "Ações",
    status_label: "Status",
    answered: "Respondida",
    not_answered: "Não respondida",
    pause_keep_camera: "Não feche a aba de prova e não oculte a câmera durante a pausa. Caso isso ocorra será registrado como saída de prova.",
    pause_return_before_end: "Retorne antes do tempo finalizar, caso contrário, será avisado ao fiscal que a pausa finalizou e o candidato não retornou.",
    pause_end_hint: "Para voltar para a prova, clique no botão “Encerrar pausa”.",
    end_pause: "Encerrar pausa",
    ending_pause: "Encerrando pausa",
    granted_time: "Tempo concedido",
    pause_starts_in: "Sua pausa irá iniciar em",
    question_remaining_time: "Tempo restante da questão",
    remaining_time: "Tempo restante",
    pause_remaining_time: "Tempo restante de pausa",
    finish_confirm_title: "Deseja encerrar e entregar a avaliação?",
    finish_evaluation_confirm: "Você tem certeza que quer finalizar a avaliação?",
    finish_unanswered_workbooks_confirm: "Você não respondeu toda a avaliação. Existe(m) caderno(s) de prova não respondido(s). Você tem certeza que deseja finalizar?",
    finish_pending_workbooks_confirm: "Existe(m) caderno(s) de prova não finalizado(s). Você tem certeza que deseja finalizar?",
    finish_confirm_button: "Sim, desejo finalizar",
    finishing_evaluation: "Finalizando avaliação",
    finish_warning: "Ao finalizar você não poderá mais realizar alterações",
    understood: "Entendi",
    unstable_connection: "Sua conexão está instável...",
    finish_all_workbooks_instruction: 'Ao terminar de responder TODOS os cadernos, clique no botão "Encerrar e entregar avaliação", que finalizará sua avaliação.',
    request_pause_title: "Pedir Pausa",
    name_label: "Nome",
    pause_request_explanation: "Ao solicitar pausa, caso aprovada pelo fiscal, serão concedidos alguns minutos para que você se ausente do computador.",
    pause_reason_label: "Justifique o motivo da pausa",
    report_action_placeholder: "Ação a ser relatada",
    character_count: "Número de caracteres",
    close: "Fechar",
    remove: "Remover",
    send: "Enviar",
    pause_reason_min_error: "O campo de Justificativa deve ter pelo menos 5 caracteres.",
    candidate_environment: "Ambiente do candidato",
    chat_with: "Chat de {name}",
    welcome: "Bem-vindo",
    login_subtitle: "Acesse sua conta para continuar sua avaliação.",
    cpf_or_email: "CPF ou e-mail",
    cpf: "CPF",
    email: "E-mail",
    password: "Senha",
    type_cpf_or_email: "Digite seu CPF ou e-mail",
    type_cpf: "Digite seu CPF",
    type_email: "Digite seu e-mail",
    type_password: "Digite sua senha",
    show_password: "Mostrar senha",
    hide_password: "Ocultar senha",
    enter: "Entrar",
    login_hero_title: "Sua avaliação começa aqui.",
    login_hero_description: "Um ambiente organizado para você se concentrar, acompanhar seu tempo e realizar cada etapa com tranquilidade.",
    evaluation_access: "Acesso à avaliação",
    choose_institution: "Escolha sua instituição",
    select_institution_hint: "Selecione a instituição responsável pelo seu processo seletivo para continuar.",
    access_candidate_environment: "Acessar ambiente do candidato",
    no_institution_available: "Nenhuma instituição disponível",
    try_again_later: "Tente novamente em alguns instantes.",
    recover_password_title: "Recuperar senha",
    recover_password_hint: "Informe seu CPF para receber o link de recuperação.",
    recover: "Recuperar",
    recovery_link_sent: "Um link de recuperação foi enviado para o seu e-mail.",
    change_password_title: "Alterar senha",
    change_password_hint: "Digite sua nova senha e confirme para continuar.",
    new_password: "Nova senha",
    confirm_password: "Confirmar senha",
    type_new_password: "Digite sua nova senha",
    type_confirm_password: "Repita sua nova senha",
    save_password: "Salvar senha",
    password_changed_success: "Senha alterada com sucesso.",
    invalid_recovery_token: "Este token de recuperação é inválido.",
    terms_stage: "Termos",
    preparation_stage: "Preparação",
    rules_stage: "Regras",
    evaluation_stage: "Avaliação",
    terms_ready_title: "Dispositivo pronto",
    terms_ready_hint: "Confira os termos e avance para a próxima etapa.",
    accept_terms_permissions: "Aceitar termos e conceder permissões",
    evaluation_not_started: "Avaliação ainda não começou",
    starts_at: "Início",
    ends_at: "Encerramento",
    starts_in: "Começa em",
    rules_accept_title: "Aceite das regras",
    accept_rules: "Aceitar regras",
    document_step: "Etapa de documento",
    face_step: "Etapa de rosto",
    movement_step: "Etapa de movimentos",
    request_proctor_review: "Pedir análise ao fiscal",
    support_with_proctor: "Atendimento com o fiscal",
    support_channel: "Canal de suporte",
    message_placeholder: "Mensagem...",
    messages: "Mensagens",
    requests: "Solicitações",
    open_chat: "Abrir chat",
    minimize_chat: "Minimizar chat",
    loading_data: "Carregando dados. Por favor, aguarde.",
    loading_environment: "Aguarde enquanto preparamos seu ambiente.",
    change_camera: "Alterar câmera",
    change_microphone: "Alterar microfone",
    select_camera: "Selecione a câmera",
    select_microphone: "Selecione o microfone",
    save_finish: "Salvar e finalizar",
    save_changes: "Salvar alterações",
    make_login: "Faça login",
    no_camera_found: "Nenhuma câmera encontrada",
    no_microphone_found: "Nenhum microfone encontrado",
    camera_permission_denied: "Você bloqueou seu acesso à câmera. Para liberá-lo, vá nas configurações do seu navegador.",
    camera_permission_dismissed: "Aceite as permissões de acesso à câmera para poder avançar.",
    camera_start_error: "Não foi possível acessar sua câmera. Conecte uma câmera, feche outras aplicações e tente novamente.",
    microphone_start_error: "Não foi possível acessar seu microfone. Conecte um microfone, feche outras aplicações e tente novamente.",
    media_not_found: "Não foi reconhecida nenhuma câmera ou microfone conectado ao computador. Conecte-os e tente novamente.",
    loading: "Carregando...",
    loading_messages: "Carregando mensagens...",
    send_message: "Enviar mensagem",
    type_message: "Digite uma mensagem...",
    readonly_proctor_channel: "Este canal permite apenas mensagens do fiscal.",
    camera: "Câmera",
    microphone: "Microfone",
    camera_microphone: "Câmera e microfone",
    camera_option: "Câmera {number}",
    microphone_option: "Microfone {number}",
    grant_camera_permissions: "Aceite as permissões de acesso à câmera para poder avançar.",
    request_camera_microphone_permissions: "Solicitar permissões de câmera e microfone",
    access_fullscreen_evaluation: "Acessar ambiente de avaliação em tela cheia",
    camera_shared: "Vídeo compartilhado",
    external_camera_required_title: "Conecte a câmera externa",
    external_camera_required_hint: "Este processo exige câmera externa conectada pelo celular. Abra o link da câmera externa no celular e mantenha a transmissão ativa para continuar.",
    external_camera_terms_title: "Câmera externa obrigatória",
    external_camera_terms_hint: "Escaneie o QR Code com o celular para abrir a câmera externa já autenticada. Depois de conectar, este item ficará marcado e você poderá aceitar as regras.",
    external_camera_status_connected: "Câmera externa conectada",
    external_camera_status_pending: "Aguardando conexão da câmera externa",
    external_camera_open_link: "Abrir link da câmera externa",
    external_camera_link_loading: "Gerando link da câmera externa...",
    external_camera_link_error: "Não foi possível gerar o link da câmera externa. Tente novamente.",
    external_camera_wait_to_continue: "Conecte a câmera externa para continuar.",
    audio_shared: "Áudio compartilhado",
    screen_shared: "Tela compartilhada",
    face_detected: "Rosto detectado",
    movements_confirmed: "Movimentos confirmados",
    microphone_validated: "Microfone validado",
    validating: "Validando...",
    send_to_validation: "Enviar para validação",
    evaluation_rules: "Regras da avaliação",
    accept_evaluation_rules: "Aceitar regras da avaliação",
    join_interview_queue: "Entrar na fila de chamada",
    enter_call: "Entrar em chamada",
    interview_call_hint: 'Para entrar em chamada, dentro do horário de sua avaliação, use a aba abaixo e clique em "Entrar em chamada".',
    login: "Fazer login",
    back: "Voltar",
    logout: "Sair",
    save_appeal: "Salvar recurso",
    saving_appeal: "Salvando recurso",
    scheduled_evaluation: "Avaliação agendada",
    join_interview_queue_short: "Entrar na fila",
    choose_exam_position: "Escolha um dos cargos para fazer a prova",
    preparing_selection_process: "Preparando o processo seletivo",
    loading_settings_steps: "Carregando suas configurações e etapas.",
    other_window_warning: "Você já possui uma outra janela deste sistema aberta. Feche-a e atualize esta página para continuar.",
    waiting_interview_queue: "Você está na fila para a entrevista",
    waiting_queue: "Você está na fila",
    queue_position: "Posição",
    share_full_screen: "Compartilhar tela cheia",
    accept_terms_permissions_full: "Aceitar termos e conceder permissões",
    full_screen_hint_title: "Compartilhe a tela inteira",
    full_screen_hint: "Selecione a opção de tela cheia na janela do navegador.",
    only_one_monitor_screen_share: "Para compartilhar a tela, você deve estar com apenas um monitor.",
    share_full_screen_to_continue: "Compartilhe a tela inteira para avançar.",
    go_to_appeals_section: "Ir para a seção de recursos",
    information: "Informações",
    device_verification: "Verificação do dispositivo",
    complete_requirements: "Complete os requisitos para avançar",
    video_sharing: "Compartilhamento de vídeo",
    audio_sharing: "Compartilhamento de áudio",
    full_screen_sharing: "Compartilhamento de tela cheia",
    completed: "concluído",
    requesting_permissions: "Solicitando permissões",
    confirm_browser_access: "Confirme o acesso na janela do navegador.",
    entering_interview_queue: "Entrando na fila para entrevista...",
    entering_queue: "Entrando na fila...",
    exam_time_after_access: "O tempo de prova iniciará após o acesso. Tempo de prova após iniciar: {minutes} min",
    before_start: "Antes de começar",
    read_accept_rules_title: "Leia e aceite as regras da avaliação",
    read_accept_rules_description: "Revise todas as orientações com atenção. O aceite confirma que você está pronto para iniciar.",
    loading_accessibility: "Carregando...",
    detected: "Detectado",
    not_detected: "Não detectado",
    objects: "Objetos",
    server_response_error: "Erro ao pegar resposta do servidor",
    internet_connection_error: "Erro ao pegar resposta do servidor. Você está conectado à internet?",
    evaluation_steps: "Etapas da avaliação",
    candidate: "Candidato",
    start_time: "Hora de início",
    end_time: "Hora de encerramento",
    process_start_time: "Hora de início do processo",
    process_end_time: "Hora de encerramento do processo",
    started_at: "Iniciado em",
    finishes_at: "Finaliza em",
    evaluation_description: "Descrição da avaliação",
    return_fullscreen_title: "Volte para a tela cheia",
    return_fullscreen_hint: "Para continuar a avaliação, acesse novamente o ambiente em tela cheia.",
    identity_validation: "Validação de identidade",
    send_document_validation_title: "Envie seus documentos para validação",
    confirm_face_movement_microphone: "Confirme rosto, movimentos e microfone",
    readable_document_requirement: "Documento legível e rosto visível",
    confirm_document_first: "Confirme o documento primeiro",
    document_validation_instruction: "Fotografe seu rosto e o documento antes de avançar para as demais validações.",
    photograph_face_document: "Fotografar rosto e documento",
    take_new_photos: "Tirar novas fotos",
    manual_review_available: "Análise manual disponível",
    document_validation: "Validação de documento",
    document_sent_to_proctor: "Documento enviado ao fiscal",
    document_sent_to_proctor_hint: "Aguarde a análise do fiscal para continuar.",
    validation_connection_hint: "A validação depende da conexão com o fiscal. Aguarde alguns instantes e tente novamente.",
    evaluation_page_exit_registered: "Foi registrado que você saiu da página de avaliação.",
    pause_request_connection_error: "Não foi possível concluir sua solicitação de pausa. Verifique se sua conexão está estável.",
    request_help_release_proctor: "Pedir liberação ao fiscal",
    validation_in_progress: "Validação em andamento",
    validation_in_progress_hint: "Continue seguindo as instruções na tela até concluir os requisitos.",
    request_in_progress: "Solicitação em andamento",
    wait_proctor_response: "Aguarde a resposta do fiscal.",
    waiting_for_proctor_decision: "Esperando decisão do fiscal...",
    automatic_validation_not_configured: "A validação automática não está configurada. Solicite a liberação ao fiscal.",
    capture_send_error: "Não foi possível enviar a captura. Tente novamente.",
    sending_release_request: "Enviando pedido de liberação...",
    access_evaluation: "Acessar avaliação",
    photograph_face_document_title: "Fotografe seu rosto e documento",
    face: "Rosto",
    document: "Documento",
    fit_face_capture: "Encaixe o rosto no centro da câmera",
    fit_document_capture: "Encaixe o documento no centro da câmera",
    review_photo_before_send: "Revise as fotos antes de enviar para validação.",
    document_tip_light: "Use um ambiente bem iluminado e evite reflexos.",
    document_tip_visible_data: "Mantenha os dados do documento visíveis.",
    document_tip_not_repeated: "Após a aprovação, esta etapa não será repetida neste processo.",
    face_photo: "Foto do rosto",
    document_photo: "Foto do documento",
    not_captured_yet: "Ainda não capturada",
    retake_face: "Tirar rosto novamente",
    retake_document: "Tirar documento novamente",
    restart_photos: "Recomeçar fotos",
    take_face_photo: "Tirar foto do rosto",
    take_document_photo: "Tirar foto do documento",
    preparing_evaluation: "Preparando sua avaliação",
    loading_rules_workbooks_settings: "Carregando regras, cadernos e configurações.",
    approved_title: "Aprovada!",
    denied_title: "Recusada!",
    release_request_approved: "Sua solicitação de liberação foi aprovada pelo fiscal.",
    release_request_denied_hint: "Sua solicitação de liberação foi recusada pelo fiscal. Verifique se sua câmera mostra uma imagem nítida e se sua conexão está estável.",
    candidate_face: "Rosto do candidato",
    document_validated: "Documento validado.",
    document_approved_by_proctor: "Documento aprovado pelo fiscal.",
    capture_denied_by_proctor: "O fiscal recusou a captura. Você pode tirar uma nova foto e enviar novamente.",
    document_already_approved: "Documento já aprovado.",
    face_not_detected: "Rosto não detectado",
    adjust_camera_position: "Ajuste a posição da câmera e mantenha seu rosto visível.",
    camera_preparing_image: "A câmera ainda está preparando a imagem. Aguarde alguns segundos.",
    face_photo_captured_next_document: "Foto do rosto capturada. Agora fotografe o documento.",
    document_photo_captured_review: "Foto do documento capturada. Confira as duas imagens antes de enviar.",
    analyzing_image_audio: "Analisando imagem e áudio",
    stay_visible_camera: "Mantenha-se visível diante da câmera.",
    multiple_faces_detected: "Mais de um rosto detectado",
    stay_alone_frame: "Permaneça sozinho no enquadramento para continuar.",
    center_face_title: "Centralize seu rosto",
    center_face_hint: "Olhe para a câmera e mantenha o rosto dentro do enquadramento.",
    turn_face_right_title: "Vire o rosto para a direita",
    turn_face_left_title: "Vire o rosto para a esquerda",
    turn_face_hint: "Faça o movimento devagar e aguarde a confirmação.",
    validate_microphone_title: "Valide o microfone",
    validate_microphone_hint: "Diga em voz alta: Estou aqui.",
    validation_completed_title: "Validação concluída",
    validation_completed_hint: "Seu dispositivo está pronto. Acesse a avaliação abaixo.",
    question_cleared_success: "Questão {number}) limpa com sucesso",
    question_answered_success: "Questão {number}) respondida com sucesso",
    loading_question: "Carregando questão",
    recovering_saved_answers: "Recuperando sua posição e as respostas salvas.",
    listen_question_statement: "Ouvir enunciado da questão",
    listen_general_statement: "Ouvir enunciado geral",
    listen_alternative: "Ouvir alternativa {letter}",
    answer_question_label: "Resposta",
    answer_question_placeholder: "Resposta da questão {number}).",
    blocked_after_pause: "Você não pode mais alterar a resposta desta questão pois realizou uma pausa após visualizá-la.",
    open_question_draft: "Abrir rascunho da questão {number})",
    clear_question_answer: "Limpar resposta da questão {number})",
    access_question: "Acessar questão {number}",
    access_question_button: "Acessar questão",
    type_label: "Tipo",
    discipline: "Disciplina",
    alternatives: "Alternativas",
    general_statement: "Enunciado geral",
    solution: "Solução",
    question_set: "Conjunto de questões",
    question_singular: "questão",
    questions_plural: "questões",
    single_question: "Questão única",
    essay_question: "Questão dissertativa",
    question_from: "Questão de {source}",
    camera_off: "Câmera desligada",
    candidate_information: "Informações do candidato",
    evaluation_contains_workbooks: "A avaliação contém os seguintes cadernos:",
    workbooks_separated_tabs: "Os cadernos estão separados por abas logo abaixo.",
    finish_workbook_to_continue: "Ao finalizar um caderno, você poderá avançar para o próximo.",
    click_tabs_questions: "Clique nas abas para responder as questões do respectivo caderno.",
    click_tabs_questions_redaction: "Clique nas abas para responder as questões ou redação do respectivo caderno.",
    questionnaire_autosave_hint: "O questionário é salvo automaticamente a cada 30 segundos ou ao finalizá-lo.",
    multiple_choice_autosave_hint: "Questões de múltipla escolha são salvas automaticamente ao responder.",
    essay_question_autosave_hint: "Questões dissertativas/discursivas são salvas automaticamente a cada 30 segundos ou ao avançar para a próxima questão.",
    redaction_autosave_hint: "A redação é salva automaticamente a cada 30 segundos.",
    supervisor_attention_instruction: 'Para indicar onde o fiscal deve ler, grife o texto e clique no botão "Chamar Atenção" na janela do fiscal.',
    oral_evaluation_call_description: "Esta é uma avaliação oral em que o candidato entrará em chamada com os avaliadores.",
    waiting_for_proctor: "Esperando fiscal...",
    participants: "Participantes",
    view_shared_screen: "Visualizar tela compartilhada",
    view_camera: "Visualizar câmera",
    evaluation_information: "Informações da avaliação",
    general_information: "Informação geral",
    scheduled_datetime: "Data/hora agendada",
    until: "Até",
    no_records_found: "Nenhum registro encontrado",
    started: "Iniciou",
    returned: "Retornou",
    paused: "Pausou",
    room: "Sala",
    resize: "Ajustar tamanho",
    move: "Mover",
    call_attention: "Chamar atenção",
    calling_attention: "Chamando atenção...",
    enter_call_button: "Entrar na chamada",
    evaluation_time: "Tempo de avaliação",
    disconnect_screen_share: "Desconectar compartilhamento",
    share_screen: "Compartilhar tela",
    leave_call: "Sair da chamada",
    hide_chat: "Esconder chat",
    show_chat: "Mostrar chat",
    hide_participants: "Esconder participantes",
    show_participants: "Mostrar participantes",
    hide_information: "Esconder informações",
    show_information: "Mostrar informações",
    hide: "Ocultar",
    show: "Mostrar",
    start_pause_records: "Registros de início/pausa",
    show_more: "Mostrar mais",
    show_less: "Mostrar menos",
    appeal_section_title: "Recurso",
    appeal_question: "Questão",
    appeal_reason: "Justificativa",
    appeal_request: "Solicitação",
    create_question_appeal_title: "Cadastrar recurso de questão",
    create_question_appeal_hint: "Cadastre um recurso de uma questão do seu sistema.",
    select_proof: "Selecione uma prova",
    select_question: "Selecione uma questão",
    no_question_selected: "Nenhuma questão selecionada",
    appeal_facts_description: "Descrição dos fatos",
    appeal_files_max: "Imagens/arquivos do recurso (máximo 10 arquivos)",
    question_appeals_list_title: "Lista de recursos de questões",
    question_appeals_list_hint: "Aqui são listados todos os recursos de questões criados por você.",
    search_appeal_placeholder: "Pesquisar pelo nome do recurso",
    add_new_appeal: "Adicionar novo recurso",
    closing_date: "Data de encerramento",
    manage_appeal: "Gerenciar recurso",
    delete_appeal: "Deletar recurso",
    no_appeal_found: "Nenhum recurso encontrado",
    confirm_delete_appeal: "Sim, desejo apagar",
    delete_appeal_warning: "Ao deletar este recurso, ele não estará mais disponível para o elaborador responder.",
    deadline_datetime: "Data e hora limite",
    no_response_found: "Nenhuma resposta encontrada",
    canceled_question: "Questão anulada",
    view_question: "Ver questão",
    notice: "Aviso",
    attention: "Atenção",
    accept_button: "Aceito",
    accepting_rules_takes_photo: "Ao aceitar as regras, uma foto sua será registrada.",
  },
  En: {
    language_label: "Language",
    theme_label: "Theme",
    workbooks: "Booklets",
    answered_questions: "Which questions have been answered?",
    start_evaluation: "Start evaluation",
    start_evaluation_title: "Evaluation question booklet",
    start_evaluation_hint: 'Click "Start evaluation" to begin',
    workbook_finished_title: "Question booklet completed",
    workbook_finished_hint: "You reached the end of this booklet",
    redaction_sheet: "Essay sheet",
    support_text: "Supporting text",
    statement: "Prompt",
    save_finish_redaction: "Save and finish essay",
    redaction_finished_title: "Essay completed successfully",
    redaction_finish_confirm_title: "Are you sure you want to finish the essay?",
    redaction_finish_warning: "After finishing, you will not be able to make changes to this essay",
    redaction_finished_card_title: "Essay booklet completed",
    redaction_finished_hint: "You finished this booklet",
    max_lines_reached: "The maximum number of {count} lines has been reached",
    line_limit_exceeded: "You exceeded the limit of {count} lines!",
    warning_title: "Warning!",
    title_placeholder: "Title",
    go_to_other_workbooks: "Go to another booklet?",
    next_workbook_hint: "Click below to move to the next booklet",
    next_evaluation: "Next evaluation",
    all_workbooks_finished: "All booklets are complete. Do you want to submit the evaluation?",
    finish_and_submit_evaluation: "Finish and submit evaluation",
    previous: "Previous",
    next: "Next",
    back_to_top: "Back to top",
    question: "Question",
    answer_question_to_continue: "Answer the question to continue",
    answered_exclamation: "Answered!",
    correct_answer: "Correct",
    answer: "Answer",
    response_date: "Answer date",
    response_files: "Answer image(s)/file(s)",
    appeal_files: "Appeal image(s)/file(s)",
    approved_status: "Approved",
    rejected_status: "Rejected",
    answered_label: "Answered",
    selected_question: "Selected question",
    question_type: "Question type",
    answers_from: "Answers from {name} - {proof}",
    required: "Required",
    optional: "Optional",
    save_finish_questionnaire: "Save and finish questionnaire",
    error_title: "Error!",
    finished_title: "Finished!",
    ok: "OK",
    cancel: "Cancel",
    finish: "Finish",
    questionnaire_finish_success: "Questionnaire completed successfully!",
    questionnaire_finish_confirm_title: "Are you sure you want to finish the questionnaire?",
    questionnaire_finish_warning: "After finishing, you will not be able to make changes to this questionnaire",
    generic_error: "Something went wrong. Please try again",
    questionnaire_finished_title: "Questionnaire completed successfully",
    questionnaire_finished_hint: "You reached the end of this booklet",
    finalized_success_title: "Evaluation completed successfully",
    finalized_success_kicker: "Evaluation completed",
    finalized_success_description: "Review your answers, results, and essays made available for this process.",
    available_results: "Available results",
    answer_sheet_title: "Sheet with your answers",
    accuracy_sheet_title: "Correct and incorrect answers",
    exam_booklet_title: "Exam booklet",
    candidate_name: "Candidate name",
    registration_number: "Registration number",
    proof: "Exam",
    result: "Result",
    correct: "Correct",
    wrong: "Wrong",
    no_answer: "No answer",
    download_answer_sheet: "Download answer sheet",
    download_accuracy_sheet: "Download correct and incorrect answers report",
    download_exam_booklet: "Download exam booklet",
    logout_button: "Sign out",
    generated_at: "Generated at",
    pdf_answer_sheet: "Answer report",
    evaluation_in_progress: "Evaluation in progress",
    evaluation_workbooks_title: "Your evaluation booklets",
    oral_evaluation: "Oral evaluation",
    request_pause: "Request pause",
    start_pause: "Start pause",
    pause_request_pending: "Your pause request is pending",
    pause_request_denied: "Your pause request was denied by the proctor",
    pause_request_accepted: "Your pause request was accepted!",
    pause_started_answers_locked: "When you start the pause, you will no longer be able to change answers for questions you have already viewed.",
    pause_access_questions_hint: "To access these questions, click the question in the answer control. Example:",
    answered_question_short: "Answered?",
    actions: "Actions",
    status_label: "Status",
    answered: "Answered",
    not_answered: "Not answered",
    pause_keep_camera: "Do not close the exam tab or hide the camera during the pause. If that happens, it will be recorded as leaving the exam.",
    pause_return_before_end: "Return before the time ends, otherwise the proctor will be notified that the pause ended and the candidate did not return.",
    pause_end_hint: "To return to the exam, click “End pause”.",
    end_pause: "End pause",
    ending_pause: "Ending pause",
    granted_time: "Granted time",
    pause_starts_in: "Your pause will start in",
    question_remaining_time: "Question time remaining",
    remaining_time: "Time remaining",
    pause_remaining_time: "Pause time remaining",
    finish_confirm_title: "Do you want to finish and submit the evaluation?",
    finish_evaluation_confirm: "Are you sure you want to finish the evaluation?",
    finish_unanswered_workbooks_confirm: "You have not answered the entire evaluation. There are unanswered exam booklets. Are you sure you want to finish?",
    finish_pending_workbooks_confirm: "There are unfinished exam booklets. Are you sure you want to finish?",
    finish_confirm_button: "Yes, submit",
    finishing_evaluation: "Finishing evaluation",
    finish_warning: "After submitting, you will no longer be able to make changes",
    understood: "Understood",
    unstable_connection: "Your connection is unstable...",
    finish_all_workbooks_instruction: 'When you finish answering ALL booklets, click "Finish and submit evaluation" to submit your evaluation.',
    request_pause_title: "Request pause",
    name_label: "Name",
    pause_request_explanation: "When you request a pause, if approved by the proctor, a few minutes will be granted so you can step away from the computer.",
    pause_reason_label: "Explain the reason for the pause",
    report_action_placeholder: "Action to report",
    character_count: "Character count",
    close: "Close",
    remove: "Remove",
    send: "Send",
    pause_reason_min_error: "The justification field must have at least 5 characters.",
    candidate_environment: "Candidate area",
    chat_with: "Chat with {name}",
    welcome: "Welcome",
    login_subtitle: "Access your account to continue your evaluation.",
    cpf_or_email: "CPF or email",
    cpf: "CPF",
    email: "Email",
    password: "Password",
    type_cpf_or_email: "Enter your CPF or email",
    type_cpf: "Enter your CPF",
    type_email: "Enter your email",
    type_password: "Enter your password",
    show_password: "Show password",
    hide_password: "Hide password",
    enter: "Sign in",
    login_hero_title: "Your evaluation starts here.",
    login_hero_description: "An organized environment to help you focus, track your time, and complete each step calmly.",
    evaluation_access: "Evaluation access",
    choose_institution: "Choose your institution",
    select_institution_hint: "Select the institution responsible for your selection process to continue.",
    access_candidate_environment: "Access candidate area",
    no_institution_available: "No institution available",
    try_again_later: "Please try again in a few moments.",
    recover_password_title: "Recover password",
    recover_password_hint: "Enter your CPF to receive the recovery link.",
    recover: "Recover",
    recovery_link_sent: "A recovery link has been sent to your email.",
    change_password_title: "Change password",
    change_password_hint: "Enter and confirm your new password to continue.",
    new_password: "New password",
    confirm_password: "Confirm password",
    type_new_password: "Enter your new password",
    type_confirm_password: "Repeat your new password",
    save_password: "Save password",
    password_changed_success: "Password changed successfully.",
    invalid_recovery_token: "This recovery token is invalid.",
    terms_stage: "Terms",
    preparation_stage: "Preparation",
    rules_stage: "Rules",
    evaluation_stage: "Evaluation",
    terms_ready_title: "Device ready",
    terms_ready_hint: "Review the terms and move to the next step.",
    accept_terms_permissions: "Accept terms and grant permissions",
    evaluation_not_started: "Evaluation has not started yet",
    starts_at: "Starts at",
    ends_at: "Ends at",
    starts_in: "Starts in",
    rules_accept_title: "Rules acceptance",
    accept_rules: "Accept rules",
    document_step: "Document step",
    face_step: "Face step",
    movement_step: "Movement step",
    request_proctor_review: "Request proctor review",
    support_with_proctor: "Support with the proctor",
    support_channel: "Support channel",
    message_placeholder: "Message...",
    messages: "Messages",
    requests: "Requests",
    open_chat: "Open chat",
    minimize_chat: "Minimize chat",
    loading_data: "Loading data. Please wait.",
    loading_environment: "Please wait while we prepare your environment.",
    change_camera: "Change camera",
    change_microphone: "Change microphone",
    select_camera: "Select camera",
    select_microphone: "Select microphone",
    save_finish: "Save and finish",
    save_changes: "Save changes",
    make_login: "Sign in",
    no_camera_found: "No camera found",
    no_microphone_found: "No microphone found",
    camera_permission_denied: "You blocked camera access. Enable it in your browser settings.",
    camera_permission_dismissed: "Allow camera permissions to continue.",
    camera_start_error: "Could not access your camera. Connect a camera, close other apps, and try again.",
    microphone_start_error: "Could not access your microphone. Connect a microphone, close other apps, and try again.",
    media_not_found: "No connected camera or microphone was detected. Connect them and try again.",
    loading: "Loading...",
    loading_messages: "Loading messages...",
    send_message: "Send message",
    type_message: "Type a message...",
    readonly_proctor_channel: "This channel only allows messages from the proctor.",
    camera: "Camera",
    microphone: "Microphone",
    camera_microphone: "Camera and microphone",
    camera_option: "Camera {number}",
    microphone_option: "Microphone {number}",
    grant_camera_permissions: "Accept camera access permissions to continue.",
    request_camera_microphone_permissions: "Request camera and microphone permissions",
    access_fullscreen_evaluation: "Open full-screen evaluation environment",
    camera_shared: "Video shared",
    external_camera_required_title: "Connect the external camera",
    external_camera_required_hint: "This process requires an external camera connected from your phone. Open the external camera link on your phone and keep the stream active to continue.",
    external_camera_terms_title: "External camera required",
    external_camera_terms_hint: "Scan the QR code with your phone to open the external camera already signed in. Once connected, this item will be checked and you can accept the rules.",
    external_camera_status_connected: "External camera connected",
    external_camera_status_pending: "Waiting for external camera connection",
    external_camera_open_link: "Open external camera link",
    external_camera_link_loading: "Generating external camera link...",
    external_camera_link_error: "Could not generate the external camera link. Try again.",
    external_camera_wait_to_continue: "Connect the external camera to continue.",
    audio_shared: "Audio shared",
    screen_shared: "Screen shared",
    face_detected: "Face detected",
    movements_confirmed: "Movements confirmed",
    microphone_validated: "Microphone validated",
    validating: "Validating...",
    send_to_validation: "Send for validation",
    evaluation_rules: "Evaluation rules",
    accept_evaluation_rules: "Accept evaluation rules",
    join_interview_queue: "Join call queue",
    enter_call: "Join call",
    interview_call_hint: 'To join the call during your evaluation time, use the tab below and click "Join call".',
    login: "Sign in",
    back: "Back",
    logout: "Log out",
    save_appeal: "Save appeal",
    saving_appeal: "Saving appeal",
    scheduled_evaluation: "Scheduled evaluation",
    join_interview_queue_short: "Join queue",
    choose_exam_position: "Choose one of the positions to take the exam",
    preparing_selection_process: "Preparing the selection process",
    loading_settings_steps: "Loading your settings and steps.",
    other_window_warning: "You already have another window of this system open. Close it and refresh this page to continue.",
    waiting_interview_queue: "You are in the interview queue",
    waiting_queue: "You are in the queue",
    queue_position: "Position",
    share_full_screen: "Share full screen",
    accept_terms_permissions_full: "Accept terms and grant permissions",
    full_screen_hint_title: "Share your entire screen",
    full_screen_hint: "Select the full screen option in the browser window.",
    only_one_monitor_screen_share: "To share your screen, you must use only one monitor.",
    share_full_screen_to_continue: "Share your entire screen to continue.",
    go_to_appeals_section: "Go to appeals section",
    information: "Information",
    device_verification: "Device verification",
    complete_requirements: "Complete the requirements to continue",
    video_sharing: "Video sharing",
    audio_sharing: "Audio sharing",
    full_screen_sharing: "Full screen sharing",
    completed: "completed",
    requesting_permissions: "Requesting permissions",
    confirm_browser_access: "Confirm access in the browser window.",
    entering_interview_queue: "Joining the interview queue...",
    entering_queue: "Joining the queue...",
    exam_time_after_access: "Exam time will start after access. Exam duration after starting: {minutes} min",
    before_start: "Before starting",
    read_accept_rules_title: "Read and accept the evaluation rules",
    read_accept_rules_description: "Review all instructions carefully. Acceptance confirms you are ready to begin.",
    loading_accessibility: "Loading...",
    detected: "Detected",
    not_detected: "Not detected",
    objects: "Objects",
    server_response_error: "Error while reading the server response",
    internet_connection_error: "Error while reading the server response. Are you connected to the internet?",
    evaluation_steps: "Evaluation steps",
    candidate: "Candidate",
    start_time: "Start time",
    end_time: "End time",
    process_start_time: "Process start time",
    process_end_time: "Process end time",
    started_at: "Started at",
    finishes_at: "Finishes at",
    evaluation_description: "Evaluation description",
    return_fullscreen_title: "Return to full screen",
    return_fullscreen_hint: "To continue the evaluation, open the full-screen environment again.",
    identity_validation: "Identity validation",
    send_document_validation_title: "Send your documents for validation",
    confirm_face_movement_microphone: "Confirm face, movements, and microphone",
    readable_document_requirement: "Readable document and visible face",
    confirm_document_first: "Confirm the document first",
    document_validation_instruction: "Photograph your face and document before moving to the remaining validations.",
    photograph_face_document: "Photograph face and document",
    take_new_photos: "Take new photos",
    manual_review_available: "Manual review available",
    document_validation: "Document validation",
    document_sent_to_proctor: "Document sent to proctor",
    document_sent_to_proctor_hint: "Wait for the proctor review to continue.",
    validation_connection_hint: "Validation depends on the proctor connection. Wait a moment and try again.",
    evaluation_page_exit_registered: "It was recorded that you left the evaluation page.",
    pause_request_connection_error: "Could not complete your pause request. Check that your connection is stable.",
    request_help_release_proctor: "Request proctor release",
    validation_in_progress: "Validation in progress",
    validation_in_progress_hint: "Keep following the on-screen instructions until the requirements are complete.",
    request_in_progress: "Request in progress",
    wait_proctor_response: "Wait for the proctor response.",
    waiting_for_proctor_decision: "Waiting for the proctor decision...",
    automatic_validation_not_configured: "Automatic validation is not configured. Request release from the proctor.",
    capture_send_error: "Could not send the capture. Please try again.",
    sending_release_request: "Sending release request...",
    access_evaluation: "Access evaluation",
    photograph_face_document_title: "Photograph your face and document",
    face: "Face",
    document: "Document",
    fit_face_capture: "Fit your face in the center of the camera",
    fit_document_capture: "Fit the document in the center of the camera",
    review_photo_before_send: "Review the photos before sending them for validation.",
    document_tip_light: "Use a well-lit environment and avoid reflections.",
    document_tip_visible_data: "Keep the document data visible.",
    document_tip_not_repeated: "After approval, this step will not be repeated in this process.",
    face_photo: "Face photo",
    document_photo: "Document photo",
    not_captured_yet: "Not captured yet",
    retake_face: "Retake face photo",
    retake_document: "Retake document photo",
    restart_photos: "Restart photos",
    take_face_photo: "Take face photo",
    take_document_photo: "Take document photo",
    preparing_evaluation: "Preparing your evaluation",
    loading_rules_workbooks_settings: "Loading rules, booklets, and settings.",
    approved_title: "Approved!",
    denied_title: "Denied!",
    release_request_approved: "Your release request was approved by the proctor.",
    release_request_denied_hint: "Your release request was denied by the proctor. Make sure your camera shows a clear image and your connection is stable.",
    candidate_face: "Candidate face",
    document_validated: "Document validated.",
    document_approved_by_proctor: "Document approved by the proctor.",
    capture_denied_by_proctor: "The proctor denied the capture. You can take a new photo and send it again.",
    document_already_approved: "Document already approved.",
    face_not_detected: "Face not detected",
    adjust_camera_position: "Adjust the camera position and keep your face visible.",
    camera_preparing_image: "The camera is still preparing the image. Wait a few seconds.",
    face_photo_captured_next_document: "Face photo captured. Now photograph the document.",
    document_photo_captured_review: "Document photo captured. Review both images before sending.",
    analyzing_image_audio: "Analyzing image and audio",
    stay_visible_camera: "Stay visible in front of the camera.",
    multiple_faces_detected: "More than one face detected",
    stay_alone_frame: "Stay alone in the frame to continue.",
    center_face_title: "Center your face",
    center_face_hint: "Look at the camera and keep your face inside the frame.",
    turn_face_right_title: "Turn your face to the right",
    turn_face_left_title: "Turn your face to the left",
    turn_face_hint: "Move slowly and wait for confirmation.",
    validate_microphone_title: "Validate the microphone",
    validate_microphone_hint: "Say out loud: I am here.",
    validation_completed_title: "Validation completed",
    validation_completed_hint: "Your device is ready. Access the evaluation below.",
    question_cleared_success: "Question {number}) cleared successfully",
    question_answered_success: "Question {number}) answered successfully",
    loading_question: "Loading question",
    recovering_saved_answers: "Recovering your position and saved answers.",
    listen_question_statement: "Listen to the question statement",
    listen_general_statement: "Listen to the general statement",
    listen_alternative: "Listen to alternative {letter}",
    answer_question_label: "Answer",
    answer_question_placeholder: "Answer to question {number}).",
    blocked_after_pause: "You can no longer change this answer because you took a pause after viewing the question.",
    open_question_draft: "Open draft for question {number})",
    clear_question_answer: "Clear answer for question {number})",
    access_question: "Open question {number}",
    access_question_button: "Open question",
    type_label: "Type",
    discipline: "Subject",
    alternatives: "Alternatives",
    general_statement: "General statement",
    solution: "Solution",
    question_set: "Question set",
    question_singular: "question",
    questions_plural: "questions",
    single_question: "Single question",
    essay_question: "Essay question",
    question_from: "Question from {source}",
    camera_off: "Camera off",
    candidate_information: "Candidate information",
    evaluation_contains_workbooks: "The evaluation contains the following booklets:",
    workbooks_separated_tabs: "The booklets are separated into tabs below.",
    finish_workbook_to_continue: "After finishing a booklet, you can move to the next one.",
    click_tabs_questions: "Click the tabs to answer the questions in that booklet.",
    click_tabs_questions_redaction: "Click the tabs to answer the questions or essay in that booklet.",
    questionnaire_autosave_hint: "The questionnaire is saved automatically every 30 seconds or when you finish it.",
    multiple_choice_autosave_hint: "Multiple-choice questions are saved automatically when answered.",
    essay_question_autosave_hint: "Essay/discursive questions are saved automatically every 30 seconds or when you move to the next question.",
    redaction_autosave_hint: "The essay is saved automatically every 30 seconds.",
    supervisor_attention_instruction: 'To indicate where the proctor should read, highlight the text and click "Call Attention" in the proctor window.',
    oral_evaluation_call_description: "This is an oral evaluation where the candidate will join a call with the evaluators.",
    waiting_for_proctor: "Waiting for proctor...",
    participants: "Participants",
    view_shared_screen: "View shared screen",
    view_camera: "View camera",
    evaluation_information: "Evaluation information",
    general_information: "General information",
    scheduled_datetime: "Scheduled date/time",
    until: "Until",
    no_records_found: "No records found",
    started: "Started",
    returned: "Returned",
    paused: "Paused",
    room: "Room",
    resize: "Resize",
    move: "Move",
    call_attention: "Call attention",
    calling_attention: "Calling attention...",
    enter_call_button: "Join call",
    evaluation_time: "Evaluation time",
    disconnect_screen_share: "Disconnect screen sharing",
    share_screen: "Share screen",
    leave_call: "Leave call",
    hide_chat: "Hide chat",
    show_chat: "Show chat",
    hide_participants: "Hide participants",
    show_participants: "Show participants",
    hide_information: "Hide information",
    show_information: "Show information",
    hide: "Hide",
    show: "Show",
    start_pause_records: "Start/pause records",
    show_more: "Show more",
    show_less: "Show less",
    appeal_section_title: "Appeal",
    appeal_question: "Question",
    appeal_reason: "Justification",
    appeal_request: "Request",
    create_question_appeal_title: "Create question appeal",
    create_question_appeal_hint: "Create an appeal for a question in your system.",
    select_proof: "Select an exam",
    select_question: "Select a question",
    no_question_selected: "No question selected",
    appeal_facts_description: "Description of facts",
    appeal_files_max: "Appeal images/files (maximum 10 files)",
    question_appeals_list_title: "Question appeals list",
    question_appeals_list_hint: "All question appeals created by you are listed here.",
    search_appeal_placeholder: "Search by appeal name",
    add_new_appeal: "Add new appeal",
    closing_date: "Closing date",
    manage_appeal: "Manage appeal",
    delete_appeal: "Delete appeal",
    no_appeal_found: "No appeal found",
    confirm_delete_appeal: "Yes, delete it",
    delete_appeal_warning: "Deleting this appeal will make it unavailable for the author to answer.",
    deadline_datetime: "Deadline date and time",
    no_response_found: "No response found",
    canceled_question: "Canceled question",
    view_question: "View question",
    notice: "Notice",
    attention: "Attention",
    accept_button: "I accept",
    accepting_rules_takes_photo: "When you accept the rules, a photo of you will be captured.",
  },
  Es: {
    language_label: "Idioma",
    theme_label: "Tema",
    theme_label: "Tema",
    workbooks: "Cuadernos",
    answered_questions: "¿Qué preguntas fueron respondidas?",
    start_evaluation: "Iniciar evaluación",
    start_evaluation_title: "Cuaderno de preguntas de la evaluación",
    start_evaluation_hint: 'Haz clic en "Iniciar evaluación" para comenzar',
    workbook_finished_title: "Cuaderno de preguntas finalizado",
    workbook_finished_hint: "Llegaste al final de este cuaderno",
    redaction_sheet: "Hoja de redacción",
    support_text: "Texto de apoyo",
    statement: "Enunciado",
    save_finish_redaction: "Guardar y finalizar redacción",
    redaction_finished_title: "Redacción finalizada con éxito",
    redaction_finish_confirm_title: "¿Seguro que deseas finalizar la redacción?",
    redaction_finish_warning: "Después de finalizar, no podrás realizar más cambios en esta redacción",
    redaction_finished_card_title: "Cuaderno de redacción finalizado",
    redaction_finished_hint: "Finalizaste este cuaderno",
    max_lines_reached: "Se alcanzó el número máximo de {count} líneas",
    line_limit_exceeded: "Superaste el límite de {count} líneas!",
    warning_title: "Aviso!",
    title_placeholder: "Título",
    go_to_other_workbooks: "¿Ir a otro cuaderno?",
    next_workbook_hint: "Haz clic abajo para avanzar al siguiente cuaderno",
    next_evaluation: "Siguiente evaluación",
    all_workbooks_finished: "Todos los cuadernos fueron finalizados. ¿Deseas entregar la evaluación?",
    finish_and_submit_evaluation: "Finalizar y entregar evaluación",
    previous: "Anterior",
    next: "Siguiente",
    back_to_top: "Volver arriba",
    question: "Pregunta",
    answer_question_to_continue: "Responde la pregunta para continuar",
    answered_exclamation: "Respondida!",
    correct_answer: "Correcta",
    answer: "Respuesta",
    response_date: "Fecha de la respuesta",
    response_files: "Imagen(es)/archivo(s) de la respuesta",
    appeal_files: "Imagen(es)/archivo(s) del recurso",
    approved_status: "Aprobado",
    rejected_status: "Rechazado",
    answered_label: "Respondida",
    selected_question: "Pregunta seleccionada",
    question_type: "Tipo de pregunta",
    answers_from: "Respuestas de {name} - {proof}",
    required: "Obligatoria",
    optional: "Opcional",
    save_finish_questionnaire: "Guardar y finalizar cuestionario",
    error_title: "Error!",
    finished_title: "Finalizada!",
    ok: "Ok",
    cancel: "Cancelar",
    finish: "Finalizar",
    questionnaire_finish_success: "Cuestionario finalizado correctamente!",
    questionnaire_finish_confirm_title: "¿Seguro que deseas finalizar el cuestionario?",
    questionnaire_finish_warning: "Después de finalizar, no podrás realizar más cambios en este cuestionario",
    generic_error: "Algo salió mal. Inténtalo de nuevo",
    questionnaire_finished_title: "Cuestionario finalizado con éxito",
    questionnaire_finished_hint: "Llegaste al final de este cuaderno",
    finalized_success_title: "Evaluación finalizada con éxito",
    finalized_success_kicker: "Evaluación finalizada",
    finalized_success_description: "Consulta tus respuestas, resultados y redacciones disponibles para este proceso.",
    available_results: "Resultados disponibles",
    answer_sheet_title: "Hoja con tus respuestas",
    accuracy_sheet_title: "Relación de aciertos y errores",
    exam_booklet_title: "Cuaderno de prueba",
    candidate_name: "Nombre del candidato",
    registration_number: "Número de inscripción",
    proof: "Prueba",
    result: "Resultado",
    correct: "Correcta",
    wrong: "Incorrecta",
    no_answer: "Sin respuesta",
    download_answer_sheet: "Descargar hoja de respuestas",
    download_accuracy_sheet: "Descargar relación de aciertos y errores",
    download_exam_booklet: "Descargar cuaderno de prueba",
    logout_button: "Cerrar sesión",
    generated_at: "Generado el",
    pdf_answer_sheet: "Informe de respuestas",
    evaluation_in_progress: "Evaluación en curso",
    evaluation_workbooks_title: "Tus cuadernos de evaluación",
    oral_evaluation: "Evaluación oral",
    request_pause: "Solicitar pausa",
    start_pause: "Iniciar pausa",
    pause_request_pending: "Tu solicitud de pausa está pendiente",
    pause_request_denied: "Tu solicitud de pausa fue rechazada por el fiscal",
    pause_request_accepted: "Tu solicitud de pausa fue aceptada!",
    pause_started_answers_locked: "Al iniciar la pausa, ya no podrás cambiar las respuestas de las preguntas que ya visualizaste.",
    pause_access_questions_hint: "Para acceder a estas preguntas, haz clic en la pregunta desde el control de respuestas. Ejemplo:",
    answered_question_short: "¿Respondida?",
    actions: "Acciones",
    status_label: "Estado",
    answered: "Respondida",
    not_answered: "No respondida",
    pause_keep_camera: "No cierres la pestaña de la prueba ni ocultes la cámara durante la pausa. Si eso ocurre, se registrará como salida de la prueba.",
    pause_return_before_end: "Regresa antes de que termine el tiempo; de lo contrario, se avisará al fiscal que la pausa terminó y el candidato no regresó.",
    pause_end_hint: "Para volver a la prueba, haz clic en “Finalizar pausa”.",
    end_pause: "Finalizar pausa",
    ending_pause: "Finalizando pausa",
    granted_time: "Tiempo concedido",
    pause_starts_in: "Tu pausa comenzará en",
    question_remaining_time: "Tiempo restante de la pregunta",
    remaining_time: "Tiempo restante",
    pause_remaining_time: "Tiempo restante de pausa",
    finish_confirm_title: "¿Deseas finalizar y entregar la evaluación?",
    finish_evaluation_confirm: "¿Seguro que deseas finalizar la evaluación?",
    finish_unanswered_workbooks_confirm: "No respondiste toda la evaluación. Hay cuaderno(s) de prueba sin responder. ¿Seguro que deseas finalizar?",
    finish_pending_workbooks_confirm: "Hay cuaderno(s) de prueba sin finalizar. ¿Seguro que deseas finalizar?",
    finish_confirm_button: "Sí, entregar",
    finishing_evaluation: "Finalizando evaluación",
    finish_warning: "Después de entregar, ya no podrás realizar cambios",
    understood: "Entendido",
    unstable_connection: "Tu conexión está inestable...",
    finish_all_workbooks_instruction: 'Cuando termines de responder TODOS los cuadernos, haz clic en "Finalizar y entregar evaluación" para entregar tu evaluación.',
    request_pause_title: "Solicitar pausa",
    name_label: "Nombre",
    pause_request_explanation: "Al solicitar una pausa, si el fiscal la aprueba, se concederán algunos minutos para que puedas ausentarte de la computadora.",
    pause_reason_label: "Justifica el motivo de la pausa",
    report_action_placeholder: "Acción a reportar",
    character_count: "Número de caracteres",
    close: "Cerrar",
    remove: "Eliminar",
    send: "Enviar",
    pause_reason_min_error: "El campo de justificación debe tener al menos 5 caracteres.",
    candidate_environment: "Ambiente del candidato",
    chat_with: "Chat de {name}",
    welcome: "Bienvenido",
    login_subtitle: "Accede a tu cuenta para continuar tu evaluación.",
    cpf_or_email: "CPF o correo electrónico",
    cpf: "CPF",
    email: "Correo electrónico",
    password: "Contraseña",
    type_cpf_or_email: "Ingresa tu CPF o correo electrónico",
    type_cpf: "Ingresa tu CPF",
    type_email: "Ingresa tu correo electrónico",
    type_password: "Ingresa tu contraseña",
    show_password: "Mostrar contraseña",
    hide_password: "Ocultar contraseña",
    enter: "Entrar",
    login_hero_title: "Tu evaluación comienza aquí.",
    login_hero_description: "Un ambiente organizado para concentrarte, controlar tu tiempo y completar cada etapa con tranquilidad.",
    evaluation_access: "Acceso a la evaluación",
    choose_institution: "Elige tu institución",
    select_institution_hint: "Selecciona la institución responsable de tu proceso selectivo para continuar.",
    access_candidate_environment: "Acceder al ambiente del candidato",
    no_institution_available: "No hay instituciones disponibles",
    try_again_later: "Inténtalo nuevamente en unos instantes.",
    recover_password_title: "Recuperar contraseña",
    recover_password_hint: "Ingresa tu CPF para recibir el enlace de recuperación.",
    recover: "Recuperar",
    recovery_link_sent: "Se envió un enlace de recuperación a tu correo electrónico.",
    change_password_title: "Cambiar contraseña",
    change_password_hint: "Ingresa tu nueva contraseña y confírmala para continuar.",
    new_password: "Nueva contraseña",
    confirm_password: "Confirmar contraseña",
    type_new_password: "Ingresa tu nueva contraseña",
    type_confirm_password: "Repite tu nueva contraseña",
    save_password: "Guardar contraseña",
    password_changed_success: "Contraseña cambiada con éxito.",
    invalid_recovery_token: "Este token de recuperación no es válido.",
    terms_stage: "Términos",
    preparation_stage: "Preparación",
    rules_stage: "Reglas",
    evaluation_stage: "Evaluación",
    terms_ready_title: "Dispositivo listo",
    terms_ready_hint: "Revisa los términos y avanza a la siguiente etapa.",
    accept_terms_permissions: "Aceptar términos y conceder permisos",
    evaluation_not_started: "La evaluación aún no ha comenzado",
    starts_at: "Inicio",
    ends_at: "Finalización",
    starts_in: "Comienza en",
    rules_accept_title: "Aceptación de reglas",
    accept_rules: "Aceptar reglas",
    document_step: "Etapa de documento",
    face_step: "Etapa de rostro",
    movement_step: "Etapa de movimientos",
    request_proctor_review: "Solicitar revisión del fiscal",
    support_with_proctor: "Atención con el fiscal",
    support_channel: "Canal de soporte",
    message_placeholder: "Mensaje...",
    messages: "Mensajes",
    requests: "Solicitudes",
    open_chat: "Abrir chat",
    minimize_chat: "Minimizar chat",
    loading_data: "Cargando datos. Por favor, espera.",
    loading_environment: "Espera mientras preparamos tu ambiente.",
    change_camera: "Cambiar cámara",
    change_microphone: "Cambiar micrófono",
    select_camera: "Selecciona la cámara",
    select_microphone: "Selecciona el micrófono",
    save_finish: "Guardar y finalizar",
    save_changes: "Guardar cambios",
    make_login: "Iniciar sesión",
    no_camera_found: "No se encontró ninguna cámara",
    no_microphone_found: "No se encontró ningún micrófono",
    camera_permission_denied: "Bloqueaste el acceso a la cámara. Habilítalo en la configuración del navegador.",
    camera_permission_dismissed: "Acepta los permisos de acceso a la cámara para continuar.",
    camera_start_error: "No fue posible acceder a tu cámara. Conecta una cámara, cierra otras aplicaciones e inténtalo nuevamente.",
    microphone_start_error: "No fue posible acceder a tu micrófono. Conecta un micrófono, cierra otras aplicaciones e inténtalo nuevamente.",
    media_not_found: "No se detectó ninguna cámara o micrófono conectado. Conéctalos e inténtalo nuevamente.",
    loading: "Cargando...",
    loading_messages: "Cargando mensajes...",
    send_message: "Enviar mensaje",
    type_message: "Escribe un mensaje...",
    readonly_proctor_channel: "Este canal solo permite mensajes del fiscal.",
    camera: "Cámara",
    microphone: "Micrófono",
    camera_microphone: "Cámara y micrófono",
    camera_option: "Cámara {number}",
    microphone_option: "Micrófono {number}",
    grant_camera_permissions: "Acepta los permisos de acceso a la cámara para continuar.",
    request_camera_microphone_permissions: "Solicitar permisos de cámara y micrófono",
    access_fullscreen_evaluation: "Abrir entorno de evaluación en pantalla completa",
    camera_shared: "Video compartido",
    external_camera_required_title: "Conecta la cámara externa",
    external_camera_required_hint: "Este proceso exige una cámara externa conectada desde el celular. Abre el enlace de la cámara externa en el celular y mantén la transmisión activa para continuar.",
    external_camera_terms_title: "Cámara externa obligatoria",
    external_camera_terms_hint: "Escanea el código QR con el celular para abrir la cámara externa ya autenticada. Después de conectarla, este elemento quedará marcado y podrás aceptar las reglas.",
    external_camera_status_connected: "Cámara externa conectada",
    external_camera_status_pending: "Esperando conexión de la cámara externa",
    external_camera_open_link: "Abrir enlace de la cámara externa",
    external_camera_link_loading: "Generando enlace de la cámara externa...",
    external_camera_link_error: "No fue posible generar el enlace de la cámara externa. Inténtalo nuevamente.",
    external_camera_wait_to_continue: "Conecta la cámara externa para continuar.",
    audio_shared: "Audio compartido",
    screen_shared: "Pantalla compartida",
    face_detected: "Rostro detectado",
    movements_confirmed: "Movimientos confirmados",
    microphone_validated: "Micrófono validado",
    validating: "Validando...",
    send_to_validation: "Enviar para validación",
    evaluation_rules: "Reglas de la evaluación",
    accept_evaluation_rules: "Aceptar reglas de la evaluación",
    join_interview_queue: "Entrar en la fila de llamada",
    enter_call: "Entrar en llamada",
    interview_call_hint: 'Para entrar en llamada durante el horario de tu evaluación, usa la pestaña de abajo y haz clic en "Entrar en llamada".',
    login: "Iniciar sesión",
    back: "Volver",
    logout: "Salir",
    save_appeal: "Guardar recurso",
    saving_appeal: "Guardando recurso",
    scheduled_evaluation: "Evaluación programada",
    join_interview_queue_short: "Entrar en la fila",
    choose_exam_position: "Elige uno de los cargos para realizar la prueba",
    preparing_selection_process: "Preparando el proceso selectivo",
    loading_settings_steps: "Cargando tus configuraciones y etapas.",
    other_window_warning: "Ya tienes otra ventana de este sistema abierta. Ciérrala y actualiza esta página para continuar.",
    waiting_interview_queue: "Estás en la fila para la entrevista",
    waiting_queue: "Estás en la fila",
    queue_position: "Posición",
    share_full_screen: "Compartir pantalla completa",
    accept_terms_permissions_full: "Aceptar términos y conceder permisos",
    full_screen_hint_title: "Comparte la pantalla completa",
    full_screen_hint: "Selecciona la opción de pantalla completa en la ventana del navegador.",
    only_one_monitor_screen_share: "Para compartir la pantalla, debes usar solo un monitor.",
    share_full_screen_to_continue: "Comparte la pantalla completa para continuar.",
    go_to_appeals_section: "Ir a la sección de recursos",
    information: "Información",
    device_verification: "Verificación del dispositivo",
    complete_requirements: "Completa los requisitos para continuar",
    video_sharing: "Compartir video",
    audio_sharing: "Compartir audio",
    full_screen_sharing: "Compartir pantalla completa",
    completed: "completado",
    requesting_permissions: "Solicitando permisos",
    confirm_browser_access: "Confirma el acceso en la ventana del navegador.",
    entering_interview_queue: "Entrando en la fila de entrevista...",
    entering_queue: "Entrando en la fila...",
    exam_time_after_access: "El tiempo de prueba comenzará después del acceso. Duración después de iniciar: {minutes} min",
    before_start: "Antes de comenzar",
    read_accept_rules_title: "Lee y acepta las reglas de la evaluación",
    read_accept_rules_description: "Revisa todas las instrucciones con atención. La aceptación confirma que estás listo para empezar.",
    loading_accessibility: "Cargando...",
    detected: "Detectado",
    not_detected: "No detectado",
    objects: "Objetos",
    server_response_error: "Error al leer la respuesta del servidor",
    internet_connection_error: "Error al leer la respuesta del servidor. ¿Estás conectado a internet?",
    evaluation_steps: "Etapas de la evaluación",
    candidate: "Candidato",
    start_time: "Hora de inicio",
    end_time: "Hora de finalización",
    process_start_time: "Hora de inicio del proceso",
    process_end_time: "Hora de finalización del proceso",
    started_at: "Iniciado el",
    finishes_at: "Finaliza el",
    evaluation_description: "Descripción de la evaluación",
    return_fullscreen_title: "Vuelve a pantalla completa",
    return_fullscreen_hint: "Para continuar la evaluación, accede nuevamente al ambiente en pantalla completa.",
    identity_validation: "Validación de identidad",
    send_document_validation_title: "Envía tus documentos para validación",
    confirm_face_movement_microphone: "Confirma rostro, movimientos y micrófono",
    readable_document_requirement: "Documento legible y rostro visible",
    confirm_document_first: "Confirma el documento primero",
    document_validation_instruction: "Fotografía tu rostro y el documento antes de avanzar a las demás validaciones.",
    photograph_face_document: "Fotografiar rostro y documento",
    take_new_photos: "Tomar nuevas fotos",
    manual_review_available: "Revisión manual disponible",
    document_validation: "Validación de documento",
    document_sent_to_proctor: "Documento enviado al fiscal",
    document_sent_to_proctor_hint: "Espera la revisión del fiscal para continuar.",
    validation_connection_hint: "La validación depende de la conexión con el fiscal. Espera un momento e inténtalo de nuevo.",
    evaluation_page_exit_registered: "Se registró que saliste de la página de evaluación.",
    pause_request_connection_error: "No fue posible completar tu solicitud de pausa. Verifica que tu conexión esté estable.",
    request_help_release_proctor: "Solicitar liberación al fiscal",
    validation_in_progress: "Validación en curso",
    validation_in_progress_hint: "Sigue las instrucciones en pantalla hasta completar los requisitos.",
    request_in_progress: "Solicitud en curso",
    wait_proctor_response: "Espera la respuesta del fiscal.",
    waiting_for_proctor_decision: "Esperando la decisión del fiscal...",
    automatic_validation_not_configured: "La validación automática no está configurada. Solicita la liberación al fiscal.",
    capture_send_error: "No fue posible enviar la captura. Inténtalo nuevamente.",
    sending_release_request: "Enviando solicitud de liberación...",
    access_evaluation: "Acceder a la evaluación",
    photograph_face_document_title: "Fotografía tu rostro y documento",
    face: "Rostro",
    document: "Documento",
    fit_face_capture: "Ajusta tu rostro en el centro de la cámara",
    fit_document_capture: "Ajusta el documento en el centro de la cámara",
    review_photo_before_send: "Revisa las fotos antes de enviarlas para validación.",
    document_tip_light: "Usa un ambiente bien iluminado y evita reflejos.",
    document_tip_visible_data: "Mantén visibles los datos del documento.",
    document_tip_not_repeated: "Después de la aprobación, esta etapa no se repetirá en este proceso.",
    face_photo: "Foto del rostro",
    document_photo: "Foto del documento",
    not_captured_yet: "Aún no capturada",
    retake_face: "Tomar rostro nuevamente",
    retake_document: "Tomar documento nuevamente",
    restart_photos: "Reiniciar fotos",
    take_face_photo: "Tomar foto del rostro",
    take_document_photo: "Tomar foto del documento",
    preparing_evaluation: "Preparando tu evaluación",
    loading_rules_workbooks_settings: "Cargando reglas, cuadernos y configuraciones.",
    approved_title: "Aprobada!",
    denied_title: "Rechazada!",
    release_request_approved: "Tu solicitud de liberación fue aprobada por el fiscal.",
    release_request_denied_hint: "Tu solicitud de liberación fue rechazada por el fiscal. Verifica que tu cámara muestre una imagen nítida y que tu conexión esté estable.",
    candidate_face: "Rostro del candidato",
    document_validated: "Documento validado.",
    document_approved_by_proctor: "Documento aprobado por el fiscal.",
    capture_denied_by_proctor: "El fiscal rechazó la captura. Puedes tomar una nueva foto y enviarla nuevamente.",
    document_already_approved: "Documento ya aprobado.",
    face_not_detected: "Rostro no detectado",
    adjust_camera_position: "Ajusta la posición de la cámara y mantén tu rostro visible.",
    camera_preparing_image: "La cámara aún está preparando la imagen. Espera unos segundos.",
    face_photo_captured_next_document: "Foto del rostro capturada. Ahora fotografía el documento.",
    document_photo_captured_review: "Foto del documento capturada. Revisa ambas imágenes antes de enviar.",
    analyzing_image_audio: "Analizando imagen y audio",
    stay_visible_camera: "Mantente visible frente a la cámara.",
    multiple_faces_detected: "Más de un rostro detectado",
    stay_alone_frame: "Permanece solo en el encuadre para continuar.",
    center_face_title: "Centra tu rostro",
    center_face_hint: "Mira a la cámara y mantén tu rostro dentro del encuadre.",
    turn_face_right_title: "Gira el rostro hacia la derecha",
    turn_face_left_title: "Gira el rostro hacia la izquierda",
    turn_face_hint: "Haz el movimiento despacio y espera la confirmación.",
    validate_microphone_title: "Valida el micrófono",
    validate_microphone_hint: "Di en voz alta: Estoy aquí.",
    validation_completed_title: "Validación completada",
    validation_completed_hint: "Tu dispositivo está listo. Accede a la evaluación abajo.",
    question_cleared_success: "Pregunta {number}) limpiada con éxito",
    question_answered_success: "Pregunta {number}) respondida con éxito",
    loading_question: "Cargando pregunta",
    recovering_saved_answers: "Recuperando tu posición y respuestas guardadas.",
    listen_question_statement: "Escuchar el enunciado de la pregunta",
    listen_general_statement: "Escuchar el enunciado general",
    listen_alternative: "Escuchar alternativa {letter}",
    answer_question_label: "Respuesta",
    answer_question_placeholder: "Respuesta de la pregunta {number}).",
    blocked_after_pause: "Ya no puedes cambiar esta respuesta porque realizaste una pausa después de ver la pregunta.",
    open_question_draft: "Abrir borrador de la pregunta {number})",
    clear_question_answer: "Limpiar respuesta de la pregunta {number})",
    access_question: "Acceder a la pregunta {number}",
    access_question_button: "Acceder a la pregunta",
    type_label: "Tipo",
    discipline: "Disciplina",
    alternatives: "Alternativas",
    general_statement: "Enunciado general",
    solution: "Solución",
    question_set: "Conjunto de preguntas",
    question_singular: "pregunta",
    questions_plural: "preguntas",
    single_question: "Pregunta única",
    essay_question: "Pregunta dissertativa",
    question_from: "Pregunta de {source}",
    camera_off: "Cámara apagada",
    candidate_information: "Información del candidato",
    evaluation_contains_workbooks: "La evaluación contiene los siguientes cuadernos:",
    workbooks_separated_tabs: "Los cuadernos están separados por pestañas abajo.",
    finish_workbook_to_continue: "Al finalizar un cuaderno, podrás avanzar al siguiente.",
    click_tabs_questions: "Haz clic en las pestañas para responder las preguntas del cuaderno respectivo.",
    click_tabs_questions_redaction: "Haz clic en las pestañas para responder las preguntas o redacción del cuaderno respectivo.",
    questionnaire_autosave_hint: "El cuestionario se guarda automáticamente cada 30 segundos o al finalizarlo.",
    multiple_choice_autosave_hint: "Las preguntas de opción múltiple se guardan automáticamente al responder.",
    essay_question_autosave_hint: "Las preguntas discursivas se guardan automáticamente cada 30 segundos o al avanzar a la siguiente pregunta.",
    redaction_autosave_hint: "La redacción se guarda automáticamente cada 30 segundos.",
    supervisor_attention_instruction: 'Para indicar dónde debe leer el fiscal, resalta el texto y haz clic en "Llamar Atención" en la ventana del fiscal.',
    oral_evaluation_call_description: "Esta es una evaluación oral en la que el candidato entrará en llamada con los evaluadores.",
    waiting_for_proctor: "Esperando fiscal...",
    participants: "Participantes",
    view_shared_screen: "Ver pantalla compartida",
    view_camera: "Ver cámara",
    evaluation_information: "Información de la evaluación",
    general_information: "Información general",
    scheduled_datetime: "Fecha/hora programada",
    until: "Hasta",
    no_records_found: "No se encontraron registros",
    started: "Inició",
    returned: "Regresó",
    paused: "Pausó",
    room: "Sala",
    resize: "Ajustar tamaño",
    move: "Mover",
    call_attention: "Llamar atención",
    calling_attention: "Llamando atención...",
    enter_call_button: "Entrar en la llamada",
    evaluation_time: "Tiempo de evaluación",
    disconnect_screen_share: "Desconectar pantalla compartida",
    share_screen: "Compartir pantalla",
    leave_call: "Salir de la llamada",
    hide_chat: "Ocultar chat",
    show_chat: "Mostrar chat",
    hide_participants: "Ocultar participantes",
    show_participants: "Mostrar participantes",
    hide_information: "Ocultar información",
    show_information: "Mostrar información",
    hide: "Ocultar",
    show: "Mostrar",
    start_pause_records: "Registros de inicio/pausa",
    show_more: "Mostrar más",
    show_less: "Mostrar menos",
    appeal_section_title: "Recurso",
    appeal_question: "Pregunta",
    appeal_reason: "Justificación",
    appeal_request: "Solicitud",
    create_question_appeal_title: "Registrar recurso de pregunta",
    create_question_appeal_hint: "Registra un recurso de una pregunta de tu sistema.",
    select_proof: "Selecciona una prueba",
    select_question: "Selecciona una pregunta",
    no_question_selected: "Ninguna pregunta seleccionada",
    appeal_facts_description: "Descripción de los hechos",
    appeal_files_max: "Imágenes/archivos del recurso (máximo 10 archivos)",
    question_appeals_list_title: "Lista de recursos de preguntas",
    question_appeals_list_hint: "Aquí se listan todos los recursos de preguntas creados por ti.",
    search_appeal_placeholder: "Buscar por el nombre del recurso",
    add_new_appeal: "Agregar nuevo recurso",
    closing_date: "Fecha de cierre",
    manage_appeal: "Gestionar recurso",
    delete_appeal: "Eliminar recurso",
    no_appeal_found: "No se encontró ningún recurso",
    confirm_delete_appeal: "Sí, deseo eliminar",
    delete_appeal_warning: "Al eliminar este recurso, ya no estará disponible para que el elaborador responda.",
    deadline_datetime: "Fecha y hora límite",
    no_response_found: "No se encontró ninguna respuesta",
    canceled_question: "Pregunta anulada",
    view_question: "Ver pregunta",
    notice: "Aviso",
    attention: "Atención",
    accept_button: "Acepto",
    accepting_rules_takes_photo: "Al aceptar las reglas, se registrará una foto tuya.",
  },
};

export const languageOptions = [
  { value: "Pt", label: "Português" },
  { value: "En", label: "English" },
  { value: "Es", label: "Español" },
];

export function getSelectedLanguage() {
  return window.localStorage.getItem("candidate_language") || "Pt";
}

export function setSelectedLanguage(language) {
  const selectedLanguage = languages[language] ? language : "Pt";
  window.localStorage.setItem("candidate_language", selectedLanguage);
  window.dispatchEvent(new CustomEvent("candidate_language_change", { detail: selectedLanguage }));
  return selectedLanguage;
}

export function getLanguageTexts(language) {
  return languages[language] || languages.Pt;
}

export function formatLanguageText(text, params = {}) {
  return String(text || "").replace(/\{(\w+)\}/g, (_, key) => {
    return Object.prototype.hasOwnProperty.call(params, key) ? params[key] : "";
  });
}
